import { render, staticRenderFns } from "./NewsAdd.vue?vue&type=template&id=4a0ded77&scoped=true"
import script from "./NewsAdd.vue?vue&type=script&lang=js"
export * from "./NewsAdd.vue?vue&type=script&lang=js"
import style0 from "./NewsAdd.vue?vue&type=style&index=0&id=4a0ded77&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0ded77",
  null
  
)

export default component.exports